function serializeError(error) {
    if (error instanceof Error)
        return `${error.name}: ${error.message}`;
    return String(error);
}
/**
 * Minimal structured logger. DEV prints to the real console (developer experience
 * unchanged); non-DEV forwards to whatever LogSink is attached (a real
 * analytics/crash-reporting provider in production) instead of printing.
 *
 * Constructor-injected, not a global singleton — each caller constructs and holds
 * its own instance (or receives one via DI) rather than importing a shared module-
 * level instance.
 */
export class Logger {
    constructor(_isDev = false, sink) {
        this._isDev = _isDev;
        this._sink = sink;
    }
    /** Attaches (or replaces) the sink after construction — e.g. once a real analytics provider resolves asynchronously after app boot. */
    attachSink(sink) {
        this._sink = sink;
    }
    error(message, error) {
        if (this._isDev) {
            console.error(message, error);
            return;
        }
        this._sink?.logEvent('app_error', { message, error: serializeError(error) });
    }
    warn(message, error) {
        if (this._isDev) {
            console.warn(message, error);
            return;
        }
        this._sink?.logEvent('app_warning', { message, error: serializeError(error) });
    }
}
